import Typography from '@mui/material/Typography'
import React from 'react'

import Box from '../../../Theme/Box'
import FAIcon from '../../../Theme/FAIcon'
import { FA_ICONS } from '../../../Theme/font-awesome-icon-constants'

const ContentSoftPublishPlate = ({ haloWaypointUser, isShow }) =>
  isShow && (
    <Box
      sx={(theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.pale,
        display: 'grid',
        gridTemplateColumns: '25px 1fr',
        padding: '12px 16px',
        borderRadius: '8px',
        gap: '8px',
      })}
    >
      <Box>
        <FAIcon
          iconClassName={FA_ICONS.INFO}
          color="secondary.main"
          style={{ marginTop: '3px' }}
          iconFontSize={18}
        />
      </Box>
      <Box>
        <Typography
          variant="body2bold"
          color="text.primary"
        >
          Soft Published
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
        >
          This map, published on Xbox by
          <span style={{ fontWeight: 'bold', marginLeft: '0.3em' }}>{haloWaypointUser?.display_name || 'UNKNOWN'}</span>
          , is visible on ForgeHub through the Halo API
        </Typography>
      </Box>
    </Box>
  )

export default ContentSoftPublishPlate
